import { getBootstrapData } from "@swa-ui/bootstrap";
import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

const getStateCodes = () => {
  const statesData = getBootstrapData("states-data")?.[0]?.statesData;

  return statesData?.map((state) => state.code) ?? [];
};

export const STATE_SCHEMA_FIELD_NAME = "stateProvinceRegion";

export const getStateFormFieldSchema = () =>
  yup
    .string()
    .trim()
    .required()
    .oneOf(getStateCodes())
    .label(i18n("StateFormField__LABEL").toLowerCase());
